export { brand } from "@ulaw/content-types/brand";
export { default as wordmark } from "@ulaw/content-types/assets/wordmark.png";
export { default as crest } from "@ulaw/content-types/assets/crest.jpg";
import favicon from "@ulaw/content-types/assets/favicon.png";
export function installBrandFavicon() {
  const link = document.createElement("link");
  link.rel = "icon";
  link.href = favicon;
  document.head.appendChild(link);
}
